export default defineAppConfig({
  custom: {
    pageHeader: {
      titleLocaleKey: "custom.header.title",

      logo: {
        width: 50,
        height: 50,
        imagePath: "/images/logo.png",
        altTextLocaleKey: "custom.header.logo-alt-text",
      },
    },
  },
})
